import Svg, { Path } from 'react-native-svg';

import { colors } from '../tokens';
import { glyphs, type IconName } from './paths';

export interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  strokeWidth?: number;
  /**
   * Two-tone: fill a stroke glyph with this colour while `color` still draws the stroke — how the board draws
   * the medal (C19 `fill:#fff`, C12 prize node `fill:#FFE1E7`, C15 `fill:#FCBF2B`) and the C15 flame.
   * Ignored by the already-filled logo glyphs (`apple`, `google`).
   */
  fill?: string;
}

/** The only way glyphs enter a screen. Stroke icons take `color` (and optionally `fill`); the Google mark keeps its brand fills. */
export function Icon({ name, size = 24, color = colors.ink, strokeWidth = 2, fill }: IconProps) {
  const g = glyphs[name];
  const paths = Array.isArray(g.d) ? g.d : [g.d];
  const fills: readonly string[] | undefined = 'fills' in g ? g.fills : undefined;
  const filled = 'fill' in g && g.fill === true;
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden // decorative: RN maps it to the native hide props; react-native-web emits aria-hidden
    >
      {paths.map((d, i) => (
        <Path
          key={i}
          d={d}
          fill={filled ? (fills?.[i] ?? color) : (fill ?? 'none')}
          stroke={filled ? 'none' : color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </Svg>
  );
}
